import React, { Component } from 'react';
import './App.css';
import { Pricing } from './pricing';
import { PumpChoiceSelector } from './components/PumpChoiceSelector';
import { PumpDisplay } from './components/PumpDisplay';
import { Horsepower, LEPPumpViewModel } from './components/common/LEPPumpViewModel';
import { AccessoryDisplay } from './components/AccessoryDisplay';
import { populateDualSealPumpOptions, populateSingleSealPumpOptions } from './bridgeAPIService';

interface IProps {
  showPricing: Pricing;
}

interface IState {
  choicesComplete: boolean;
  viewModel?: LEPPumpViewModel;
  showAccessories: boolean;
}


export class App extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.pumpChoicesCompleteHandler = this.pumpChoicesCompleteHandler.bind(this);
    this.populateViewModel = this.populateViewModel.bind(this);
    this.startOver = this.startOver.bind(this);
    this.state = {
      choicesComplete: false,
      showAccessories: false
    }
  }

  /**
   * Event Handler for when all options in the PumpChoiceSelector are exhausted.
   * @param status - Are all options exhausted?
   * @param viewModel - The current state of the viewModel.
   */
  private pumpChoicesCompleteHandler(status: boolean, viewModel?: LEPPumpViewModel): void {
    this.setState({
      choicesComplete: status, 
      viewModel: viewModel
    }, this.populateViewModel);
  }

  /**
   * Fill out all options available for the pump as it was configured using the PumpChoiceSelector.
   * @returns Promise
   */
  private async populateViewModel(): Promise<void> {
    if (!this.state.viewModel) {
      return;
    }
    if (this.state.viewModel.sealType === 'Single Seal' || 
        (this.state.viewModel.pumpType === 'XLGV' && this.state.viewModel.horsepower === Horsepower.TWO) ||
        (this.state.viewModel.pumpType === 'XLGH' && this.state.viewModel.horsepower === Horsepower.TWO)) {
          // populate ss view model
          if (this.state.viewModel) {
            populateSingleSealPumpOptions(this.state.viewModel);
          }
        } 
        else {
          // populate ds view model
          if (this.state.viewModel) {
            await populateDualSealPumpOptions(this.state.viewModel);
          }
        }
        this.setState({
          viewModel: this.state.viewModel
        });
  }

  private startOver(): void {
    window.location.reload();
  }

  render() {
    return (
      <div id='build-a-pump-container' className='build-a-pump-wrap bap-container'>
        <PumpChoiceSelector choicesComplete={this.pumpChoicesCompleteHandler} hideBreadcrumb={this.state.showAccessories} />
        {/* As long as all PumpChoiceSelector options have been exhausted, and we shouldn't be showing accessories, show the PumpDisplay. */}
        {this.state.choicesComplete && !this.state.showAccessories ? <PumpDisplay viewModel={this.state.viewModel} showAccessories={() => this.setState({showAccessories: true})} forceRender={() => {this.setState({})}} pricing={this.props.showPricing}/> : null}
        {/* Only show the AccessoryDisplay if we set the showAccessories flag. */}
        {this.state.showAccessories ? <AccessoryDisplay viewModel={this.state.viewModel} pricing={this.props.showPricing} pumpSelected={() => this.setState({showAccessories: false})} startOver={this.startOver}/> : null}
      </div>
    );
  }
};
